import "../scss/index.scss";

document.addEventListener("DOMContentLoaded", () => {
  currentMenuItems();
});

window.addEventListener('scroll', () => {
  scrollInView();
});

// Get all menu items and if has # remove current menu class
function currentMenuItems() {
  const navbar = document.querySelector(".navbar");
  // get all menu items that have a # in the
  const menuItems = navbar.querySelectorAll("a");
  // remove active class from all menu items
  menuItems.forEach((item) => {
    let href = item.href;
    let hash = href.includes("#");
    // check if href contains #
    if (hash) {
      // get parent
      let parent = item.parentElement;
      // remove current menu item class
      parent.classList.remove("current-menu-item");
    }
  });
}